import { render, staticRenderFns } from "./ContactMessageForm.vue?vue&type=template&id=672ec43f&scoped=true"
import script from "./ContactMessageForm.vue?vue&type=script&lang=js"
export * from "./ContactMessageForm.vue?vue&type=script&lang=js"
import style0 from "./ContactMessageForm.vue?vue&type=style&index=0&id=672ec43f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672ec43f",
  null
  
)

export default component.exports